// extracted by mini-css-extract-plugin
module.exports = {"ef_swiper":"EFSwiper_ef_swiper__Nf8QJ"};